import { createElement, setStyleAttribute } from '@syncfusion/ej2-base';
import { Tooltip } from '@syncfusion/ej2-popups';
import { getPointer, getTemplateFunction } from '../utils/helper';
import { getAngleFromValue, getLabelFormat, getElement, getLocationFromAngle } from '../utils/helper';
import { tooltipRender } from '../model/constants';
/**
 * Tooltip Module handles the tooltip of the circular gauge
 */
var GaugeTooltip = /** @class */ (function () {
    /**
     * Constructor for Tooltip module.
     * @private.
     */
    function GaugeTooltip(gauge) {
        this.gauge = gauge;
        this.element = gauge.element;
        this.tooltip = gauge.tooltip;
        this.textStyle = this.tooltip.textStyle;
        this.borderStyle = this.tooltip.border;
        this.ejTooltip = new Tooltip({
            opensOn: 'custom',
            beforeRender: this.onBeforeRender.bind(this),
            beforeOpen: this.tooltipCustomization.bind(this),
            openDelay: 0, closeDelay: 1000
        });
        this.ejTooltip.appendTo(this.element);
    }
    /**
     * Method to render the tooltip for circular gauge.
     */
    GaugeTooltip.prototype.renderTooltip = function (target) {
        var currentPointer = getPointer(target.id, this.gauge);
        var element;
        var angle;
        this.currentAxis = this.gauge.axes[currentPointer.axisIndex];
        this.currentPointer = (this.currentAxis.pointers)[currentPointer.pointerIndex];
        angle = getAngleFromValue(this.currentPointer.currentValue, this.currentAxis.visibleRange.max, this.currentAxis.visibleRange.min, this.currentAxis.startAngle, this.currentAxis.endAngle, this.currentAxis.direction === 'ClockWise') % 360;
        element = this.appendTargetElement(angle);
        if (element.getAttribute('data-tooltip-id') === null) {
            this.findPosition(angle);
            this.ejTooltip.open(element);
        }
    };
    /**
     * Method to append the target element for tooltip
     */
    GaugeTooltip.prototype.appendTargetElement = function (angle) {
        var location = getLocationFromAngle(angle, this.currentAxis.currentRadius, this.gauge.midPoint);
        var element = getElement(this.element.id + '_GaugeTooltip');
        if (element) {
            element.style.left = location.x + 'px';
            element.style.top = location.y + 'px';
        }
        else {
            element = createElement('div', {
                id: this.element.id + '_GaugeTooltip',
                styles: 'position:absolute;left:' + location.x + 'px;top:' + location.y +
                    'px;width:2px;height:2px;background:transparent'
            });
            getElement(this.element.id + '_Secondary_Element').appendChild(element);
        }
        return element;
    };
    /**
     * Method to find the position of the tooltip anchor for circular gauge.
     */
    GaugeTooltip.prototype.findPosition = function (angle) {
        switch (true) {
            case (angle >= 0 && angle <= 45):
                this.ejTooltip.position = 'RightBottom';
                break;
            case (angle >= 45 && angle < 90):
                this.ejTooltip.position = 'BottomRight';
                break;
            case (angle >= 90 && angle < 135):
                this.ejTooltip.position = 'BottomLeft';
                break;
            case (angle >= 135 && angle < 180):
                this.ejTooltip.position = 'LeftBottom';
                break;
            case (angle >= 180 && angle < 225):
                this.ejTooltip.position = 'LeftTop';
                break;
            case (angle >= 225 && angle < 270):
                this.ejTooltip.position = 'TopLeft';
                break;
            case (angle >= 270 && angle < 315):
                this.ejTooltip.position = 'TopRight';
                break;
            default:
                this.ejTooltip.position = 'RightTop';
                break;
        }
        this.ejTooltip.dataBind();
    };
    /**
     * Method to perform the tooltip for circular gauge.
     */
    GaugeTooltip.prototype.onBeforeRender = function (args) {
        var tooltipFormat = this.gauge.tooltip.format || this.currentAxis.labelStyle.format;
        var customLabelFormat = tooltipFormat && tooltipFormat.match('{value}') !== null;
        var format = this.gauge.intl.getNumberFormat({
            format: getLabelFormat(tooltipFormat), useGrouping: this.gauge.useGroupingSeparator
        });
        var content = customLabelFormat ?
            tooltipFormat.replace(new RegExp('{value}', 'g'), format(this.currentPointer.currentValue)) :
            format(this.currentPointer.currentValue);
        content = this.tooltip.template ?
            getTemplateFunction(this.tooltip.template)(this.currentAxis)[0] : content;
        var argsData = {
            cancel: false, name: tooltipRender,
            content: content,
            border: this.borderStyle,
            axis: this.currentAxis, pointer: this.currentPointer,
            textStyle: this.textStyle
        };
        this.gauge.trigger(tooltipRender, argsData);
        this.borderStyle = argsData.border;
        args.cancel = argsData.cancel;
        this.ejTooltip.content = argsData.content;
        this.textStyle = argsData.textStyle;
        this.ejTooltip.dataBind();
    };
    /**
     * Method to customize the tooltip elements for circular gauge.
     */
    GaugeTooltip.prototype.tooltipCustomization = function (args) {
        var font = this.textStyle;
        var borderColor = this.borderStyle.color;
        var border = this.borderStyle.width;
        var pointerSize = 5;
        var arrowWidth = (pointerSize - border) + 'px';
        var outerWidth;
        var innerWidth;
        args.element.classList.remove('e-popup-close');
        args.element.classList.add('e-popup-open');
        var arrowEle = args.element.querySelector('.e-arrow-tip');
        setStyleAttribute(args.element, {
            'backgroundColor': this.tooltip.fill, 'borderColor': borderColor || '#212121',
            'borderWidth': border + 'px'
        });
        setStyleAttribute(args.element.querySelector('.e-tip-content'), {
            'color': font.color, 'fontFamily': font.fontFamily, 'fontSize': font.size,
            'fontWeight': font.fontWeight, 'opacity': font.opacity.toString(), 'fontStyle': font.fontStyle
        });
        setStyleAttribute(args.element.querySelector('.e-arrow-tip'), {
            'width': 2 * (pointerSize + border) + 'px', 'height': pointerSize + border + 'px'
        });
        if (arrowEle.classList.contains('e-tip-top')) {
            pointerSize = args.element.querySelector('.e-arrow-tip').offsetHeight;
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderBottomColor': borderColor,
                'borderLeftWidth': outerWidth, 'borderRightWidth': outerWidth, 'borderBottomWidth': outerWidth,
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderBottomColor': this.tooltip.fill,
                'borderLeftWidth': innerWidth, 'borderRightWidth': innerWidth, 'borderBottomWidth': innerWidth,
                'left': border + 'px', 'top': border + 'px', 'display': 'none'
            });
        }
        else if (arrowEle.classList.contains('e-tip-bottom')) {
            pointerSize = args.element.querySelector('.e-arrow-tip').offsetHeight;
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderTopColor': borderColor,
                'borderLeftWidth': outerWidth, 'borderRightWidth': outerWidth, 'borderTopWidth': outerWidth,
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                'borderRightColor': 'transparent', 'borderLeftColor': 'transparent', 'borderTopColor': this.tooltip.fill,
                'borderLeftWidth': innerWidth, 'borderRightWidth': innerWidth, 'borderTopWidth': innerWidth,
                'left': border + 'px', 'top': '0', 'display': 'none'
            });
        }
        else if (arrowEle.classList.contains('e-tip-left')) {
            setStyleAttribute(args.element.querySelector('.e-arrow-tip'), {
                'width': pointerSize + border + 'px', 'height': 2 * (pointerSize + border) + 'px'
            });
            pointerSize = args.element.querySelector('.e-arrow-tip').offsetWidth;
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderTopColor': 'transparent', 'borderBottomColor': 'transparent', 'borderRightColor': borderColor,
                'borderTopWidth': outerWidth, 'borderBottomWidth': outerWidth, 'borderRightWidth': outerWidth
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                'borderTopColor': 'transparent', 'borderBottomColor': 'transparent', 'borderRightColor': this.tooltip.fill,
                'borderTopWidth': innerWidth, 'borderBottomWidth': innerWidth, 'borderRightWidth': innerWidth,
                'left': border + 'px', 'top': border + 'px', 'display': 'none'
            });
        }
        else {
            setStyleAttribute(args.element.querySelector('.e-arrow-tip'), {
                'width': (pointerSize + border) + 'px', 'height': 2 * (pointerSize + border) + 'px'
            });
            pointerSize = args.element.querySelector('.e-arrow-tip').offsetWidth;
            outerWidth = pointerSize + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-outer'), {
                'borderTopColor': 'transparent', 'borderBottomColor': 'transparent', 'borderLeftColor': borderColor,
                'borderTopWidth': outerWidth, 'borderBottomWidth': outerWidth, 'borderLeftWidth': outerWidth
            });
            innerWidth = (pointerSize - border) + 'px';
            setStyleAttribute(args.element.querySelector('.e-arrow-tip-inner'), {
                'borderTopColor': 'transparent', 'borderBottomColor': 'transparent', 'borderLeftColor': this.tooltip.fill,
                'borderTopWidth': innerWidth, 'borderBottomWidth': innerWidth, 'borderLeftWidth': innerWidth,
                'left': (border <= 1 ? 0 : -1) + 'px', 'top': border + 'px', 'display': 'none'
            });
        }
        this.ejTooltip.refresh(args.target);
        setStyleAttribute(args.element, {
            'display': 'block', 'transitionProperty': 'left,top',
            'transitionDuration': this.tooltip.enableAnimation ? '1000ms' : '0ms'
        });
    };
    /**
     * Get module name.
     */
    GaugeTooltip.prototype.getModuleName = function () {
        // Returns te module name
        return 'Tooltip';
    };
    /**
     * To destroy the tooltip.
     * @return {void}
     * @private
     */
    GaugeTooltip.prototype.destroy = function (gauge) {
        // Destroy method performed here
    };
    return GaugeTooltip;
}());
export { GaugeTooltip };
